import { blockBuilder } from './blockBuilder'
import { bp } from './breakpoint'
import { chart } from './chart'
import { classes } from './classes'
import { contextMenu } from './contextMenu'
import { creator } from './creator'
import { crossTable } from './crossTable'
import { datamapImport } from './datamapImport'
import { drawer } from './drawer'
import { feedbackDetail } from './feedbackDetail'
import { fileManager } from './fileManager'
import { filter } from './filter'
import { header } from './header'
import { menu } from './menu'
import { overlay } from './overlay'
import { passwordManager } from './passwordManager'
import { resizer } from './resizer'
import { tracking } from './tracking'

export * from './breakpoint.constant'

type Module = {
	bp: typeof bp
	blockBuilder: typeof blockBuilder
	chart: typeof chart
	contextMenu: typeof contextMenu
	classes: typeof classes
	crossTable: typeof crossTable
	drawer: typeof drawer
	fileManager: typeof fileManager
	filter: typeof filter
	header: typeof header
	menu: typeof menu
	overlay: typeof overlay
	tracking: typeof tracking
	resizer: typeof resizer
	creator: typeof creator
	feedbackDetail: typeof feedbackDetail
	passwordManager: typeof passwordManager
	datamapImport: typeof datamapImport
}

export const module: Module = {
	bp,
	blockBuilder,
	chart,
	contextMenu,
	classes,
	crossTable,
	drawer,
	fileManager,
	filter,
	header,
	menu,
	overlay,
	resizer,
	creator,
	tracking,
	feedbackDetail,
	passwordManager,
	datamapImport,
}

export * from './modifier'
